// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"dc72c50d","453":"0511e9fd"}[chunkId] + ".chunk.js";
};